import type { FunctionComponent } from 'react'
import React, { useContext } from 'react'

import { PillButtonPage } from '../../../../../shared/pages/PillButtonPage'
import { ToolContext } from '../../../../../shared/state/appContext'
import globalStyles from '../../../../../shared/styles/GlobalStyles.module.scss'
import { trackAppointmentBookingSelection } from '../../../../../shared/utils/tracking/tracking'
import { TechQueryFlow, TechTopicFlow } from '../../../pageFlowData'
import { techTopicData } from './data'

export const TechTopic: FunctionComponent = () => {
  const { state, dispatch } = useContext(ToolContext)
  const {
    tech: { techTopic },
    triage: { type },
  } = state

  const handleTracking = (id: string, index: number) => {
    trackAppointmentBookingSelection(type, TechTopicFlow.VIEW_NAME, { id, index })
  }

  const handleDispatch = (id: string) => {
    dispatch({ type: 'UPDATE_TECH_TOPIC', data: id })
    dispatch({ type: 'UPDATE_STEP', data: TechQueryFlow.STEP })
    dispatch({ type: 'UPDATE_PROGRESS_VALUE', data: TechQueryFlow.PROGRESS_VALUE })
  }

  const handleSubmit = (id: string, index: number) => {
    handleTracking(id, index)
    handleDispatch(id)
  }

  const { buttons, imgObj, title } = techTopicData

  return (
    <div className={globalStyles.fullWidthButton}>
      <PillButtonPage
        buttons={buttons}
        defaultValue={techTopic}
        handleSubmit={handleSubmit}
        imgObj={imgObj}
        title={title}
      />
    </div>
  )
}
